module.exports = "/_next/static/images/0b2d8830cf43fa93b83f47c9831b32fb-mgm-invite-ticket-4.jpg.webp";